export const canUserAccess = (
  pageRoles?: (string | null | undefined)[] | null,
  userRoles?: (string | null | undefined)[] | null
): boolean => {
  // ✅ If pageRoles is null/undefined/empty → allow access
  if (!pageRoles || pageRoles.length === 0) {
    return true;
  }

  // ✅ If pageRoles includes an empty element → allow access
  if (pageRoles.some((r) => !r || r.trim() === "")) {
    return true;
  }

  // 🚫 If userRoles is null/undefined/empty → deny access
  if (!userRoles || userRoles.length === 0) {
    return false;
  }

  // ✅ Allow if user has at least one of the required roles
  return pageRoles.some((pr) => userRoles.includes(pr!));
};
